/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_6_AInputs */

const en_mk_faq_6_a = /** @type {(inputs: Mk_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Bystep AI, a supported provider API key, or the official Claude Code/Codex login for coding on your computer. Select planning and review AI separately. CLI/MCP integrations remain available for other agents according to their capabilities. Provider charges and infrastructure allowances follow your choices.`)
};

const id_mk_faq_6_a = /** @type {(inputs: Mk_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih AI Bystep, API key penyedia yang didukung, atau login resmi Claude Code/Codex untuk coding di komputer sendiri. Sumber AI rencana dan review dipilih terpisah. Integrasi CLI/MCP tetap tersedia untuk agent lain sesuai kemampuan masing-masing. Biaya provider dan kuota infrastruktur mengikuti pilihanmu.`)
};

/**
* | output |
* | --- |
* | "Choose Bystep AI, a supported provider API key, or the official Claude Code/Codex login for coding on your computer. Select planning and review AI separately..." |
*
* @param {Mk_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_6_a = /** @type {((inputs?: Mk_Faq_6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_6_a(inputs)
	return en_mk_faq_6_a(inputs)
});